import axios from "axios";
import * as auth_actions from '../components/authentication/AuthenticationAction';

const token = localStorage.getItem("token");
const employeeId = JSON.parse(localStorage.getItem("state"))?.AuthenticationReducer?.userId;
const station = JSON.parse(localStorage.getItem("state"))?.AuthenticationReducer?.station;

axios.defaults.headers.common["Authorization"] = 'Bearer ' + token;

const mandoApi = (type, url, data, responseType) => {
  const options = {
    method: type,
    url: url,
    responseType: responseType,
  }
  if (data) {
    options.data = data;
  }

  return axios(options)
    .then((response) => {
      return response;
    })
    .catch((error) => {
       if(error.toString().includes('401')){
         auth_actions.logoutSuccess();
         return {code:401}
       }
       else{
        return error;
       }
    })
};

export default mandoApi;

